export default "__VITE_ASSET__DPL9E79m__"